export const pineapple = {
  'get-general-info': 'pineapple-general-info-received',
  'update-general-info': 'pineapple-general-info-updated',
  'get-check-address-messages': 'pineapple-check-address-messages-received',
  'update-check-address-messages': 'pineapple-check-address-messages-updated'
}
